// extracted by mini-css-extract-plugin
module.exports = {"actions":"Waves_actions__1IrvL","reprocess-icon":"Waves_reprocess-icon__3-kKY"};